WelcomeCtrl.$inject = ['$scope', '$rootScope', '$compile', 'CurrentUser']

export default function WelcomeCtrl($scope, $rootScope, $compile, CurrentUser) {
  $scope.user = CurrentUser.data;
  $scope.startTour = function () {
    if (!document.querySelector('lf-action-guide')) {
      var guide = $compile('<lf-action-guide context="home" />')(
        $rootScope);
      let body = document.querySelector('body')
      body.insertBefore(guide[0], body.firstChild);
    }
    $scope.$close();
  };
}



// WEBPACK FOOTER //
// ./project/modals/welcome/welcome.controller.js